import { render, staticRenderFns } from "./popupStudentFormFilter.vue?vue&type=template&id=6350984a&scoped=true&"
import script from "./popupStudentFormFilter.vue?vue&type=script&lang=js&"
export * from "./popupStudentFormFilter.vue?vue&type=script&lang=js&"
import style0 from "./popupStudentFormFilter.vue?vue&type=style&index=0&id=6350984a&scoped=true&lang=css&"
import style1 from "./popupStudentFormFilter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6350984a",
  null
  
)

export default component.exports